import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let hasRegisteredPlugin = false;

function registerScrollTrigger() {
  if (hasRegisteredPlugin) {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);
  hasRegisteredPlugin = true;
}

/**
 * How far the rail needs to travel from its start position (below viewport)
 * to its natural resting position. Computed at pin moment:
 *   rail's top from viewport = rail.offsetTop (within section)
 *   travel = viewportHeight - railTopFromViewport
 */
function getRailTravelDistance(sectionElement, railElement) {
  var railTopFromSection = railElement.offsetTop;
  var railTopFromViewport = railTopFromSection;
  return Math.max(0, window.innerHeight - railTopFromViewport);
}

export function initializeCertificationsPin() {
  if (typeof window === 'undefined') {
    return function noop() {};
  }

  registerScrollTrigger();

  var sectionElement = document.querySelector('.home-section--certifications');

  if (!sectionElement) {
    return function noop() {};
  }

  var railElement = sectionElement.querySelector('.certifications__rail');

  if (!railElement) {
    return function noop() {};
  }

  var mediaMatcher = gsap.matchMedia();

  mediaMatcher.add({
    reduceMotion: '(prefers-reduced-motion: reduce)',
    desktop: '(min-width: 1025px)',
    mobile: '(max-width: 1024px)',
  }, function setupCertificationsPin(context) {
    var conditions = context.conditions;

    if (conditions.reduceMotion || conditions.mobile) {
      sectionElement.classList.remove('home-section--certifications-pinned');
      sectionElement.classList.remove('home-section--certifications-pinned-active');
      gsap.set(railElement, { clearProps: 'y,transform' });
      return undefined;
    }

    sectionElement.classList.add('home-section--certifications-pinned');

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionElement,
        start: 'top top',
        end: function () {
          return '+=' + getRailTravelDistance(sectionElement, railElement);
        },
        pin: true,
        pinSpacing: true,
        scrub: 1,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onToggle: function onToggle(self) {
          sectionElement.classList.toggle('home-section--certifications-pinned-active', self.isActive);
        },
      },
    });

    tl.fromTo(
      railElement,
      {
        y: function () {
          return getRailTravelDistance(sectionElement, railElement);
        },
      },
      { y: 0, ease: 'none' }
    );

    return function cleanupCertificationsPin() {
      tl.kill();
      sectionElement.classList.remove('home-section--certifications-pinned');
      sectionElement.classList.remove('home-section--certifications-pinned-active');
      gsap.set(railElement, { clearProps: 'y,transform' });
    };
  });

  return function cleanupAll() {
    mediaMatcher.revert();
    sectionElement.classList.remove('home-section--certifications-pinned');
    sectionElement.classList.remove('home-section--certifications-pinned-active');
    gsap.set(railElement, { clearProps: 'y,transform' });
    ScrollTrigger.refresh();
  };
}
